import { Tabs } from "@chakra-ui/react";
import { TabsProps } from "@chakra-ui/tabs";
import React, { useEffect } from "react";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";
import reactToText from "shared/utils/ReactToText";

export const TableBoxTabs: React.FC<TabsProps> = ({ children, ...props }) => {
  const { setTitle } = useTableBoxContext();
  useEffect(() => {
    const c = React.Children.toArray(children)[props.index ?? 0];
    const title = reactToText(c);
    if (title) {
      setTitle(title);
    }
  }, [children, props.index, setTitle]);
  return (
    <Tabs display="flex" alignSelf="stretch" {...props}>
      {React.Children.map(children, (child) =>
        child
          ? React.cloneElement(child as React.ReactElement, {
              // see activeFontWeightWithConsistentWidth
              title: reactToText(child),
            })
          : null,
      )}
    </Tabs>
  );
};
